import { Locale } from 'chaika-enums';
export const textEditor = {
    textEditorPasteTitle: {
        [Locale.Ru]: `Вставка текста`,
        [Locale.Am]: `Տեքստի տեղադրում`,
        [Locale.En]: `Paste text`,
        [Locale.Pt]: 'Colar texto',
        [Locale.Ge]: `Paste text`,
    },
    textEditorPasteQuestion: {
        [Locale.Ru]: `Ваш текст похож на HTML. Как его вставить?`,
        [Locale.Am]: `Ձեր տեքստը նման է HTML-ի։ Ինչպե՞ս տեղադրել այն։`,
        [Locale.En]: `Your text looks like HTML. How should it be pasted?`,
        [Locale.Pt]: 'Seu texto parece HTML. Como deseja colá-lo?',
        [Locale.Ge]: `Your text looks like HTML. How should it be pasted?`,
    },
    textEditorKeepFormatting: {
        [Locale.Ru]: `Вставить с форматированием`,
        [Locale.Am]: `Տեղադրել ձևաչափմամբ`,
        [Locale.En]: `Paste with formatting`,
        [Locale.Pt]: 'Colar com formatação',
        [Locale.Ge]: `Paste with formatting`,
    },
    textEditorHtmlMarkupAsText: {
        [Locale.Ru]: `HTML-разметка как текст`,
        [Locale.Am]: `HTML-դասավորությունը որպես տեքստ`,
        [Locale.En]: `HTML markup as text`,
        [Locale.Pt]: 'Marcação HTML como texto',
        [Locale.Ge]: `HTML markup as text`,
    },
    textEditorDiscardFormatting: {
        [Locale.Ru]: `Вставить без форматирования`,
        [Locale.Am]: `Տեղադրել առանց ձևաչափման`,
        [Locale.En]: `Paste without formatting`,
        [Locale.Pt]: 'Colar sem formatação',
        [Locale.Ge]: `Paste without formatting`,
    },
    textEditorKeepFormattingHint: {
        [Locale.Ru]: `Сохранит жирный шрифт, списки, таблицы. При копировании из PDF форматирование обычно теряется`,
        [Locale.Am]: `Կպահպանի թավ տառատեսակը, ցուցակները, աղյուսակները։ PDF-ից պատճենելիս ձևաչափումը սովորաբար կորչում է`,
        [Locale.En]: `Keeps bold text, lists, tables. Formatting is usually lost when copying from PDF`,
        [Locale.Pt]: 'Mantém negrito, listas e tabelas. Ao copiar de um PDF, a formatação geralmente se perde',
        [Locale.Ge]: `Keeps bold text, lists, tables. Formatting is usually lost when copying from PDF`,
    },
    textEditorHtmlMarkupAsTextHint: {
        [Locale.Ru]: `HTML-теги вставляются как видимый текст (режим отладки)`,
        [Locale.Am]: `HTML-պիտակները տեղադրվում են որպես տեսանելի տեքստ (վրիպազերծման ռեժիմ)`,
        [Locale.En]: `HTML tags are pasted as visible text (debug mode)`,
        [Locale.Pt]: 'As tags HTML são coladas como texto visível (modo de depuração)',
        [Locale.Ge]: `HTML tags are pasted as visible text (debug mode)`,
    },
    textEditorDiscardFormattingHint: {
        [Locale.Ru]: `Останется только текст и переносы строк`,
        [Locale.Am]: `Կմնա միայն տեքստը և տողադարձերը`,
        [Locale.En]: `Only the text and line breaks are kept`,
        [Locale.Pt]: 'Apenas o texto e as quebras de linha são mantidos',
        [Locale.Ge]: `Only the text and line breaks are kept`,
    },
};
